import { render, staticRenderFns } from "./company-view-form.vue?vue&type=template&id=2bf81643&"
import script from "./company-view-form.ts?vue&type=script&lang=ts&"
export * from "./company-view-form.ts?vue&type=script&lang=ts&"
import style0 from "./company-view-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports